import axios from "axios";
import EventEmitter from "events";
import { StatusCodes } from "http-status-codes";
import config from "@libs/config.js";
import packageJson from "../../package.json";

const backendApiUrl = config.backend.apiUrl;

const apiErrorEvent = new EventEmitter();

const apiClient = axios.create({
    baseURL: backendApiUrl,
    cancelToken: axios.CancelToken.source().token,
    headers: {
        "X-User-Agent": `${packageJson.name} ${packageJson.version}`,
    },
});

apiClient.interceptors.request.use(
    (req) => req,
    (err) => Promise.reject(err),
);

apiClient.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response != undefined && err.response.status === StatusCodes.UNAUTHORIZED) {
            apiErrorEvent.emit("Unauthorized");
            apiClient.defaults.headers.common["Authorization"] = null;
        }

        if (err.response?.data instanceof Blob) {
            return new Promise((_, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const content = reader.result;
                        const jsonContent = JSON.parse(content);
                        if (jsonContent.error) {
                            reject(jsonContent);
                            return;
                        }
                        if (typeof content === "string") {
                            try {
                                const parsedContent = JSON.parse(content);
                                err.blobContent = content;
                                err.blobJsonContent = parsedContent;
                                err.hasBlobContent = true;
                            } catch (jsonError) {
                                err.blobContent = content;
                                err.blobJsonContent = null;
                                err.hasBlobContent = true;
                                console.log("jsonError", jsonError);
                            }
                        }

                        reject(err);
                    } catch (contentError) {
                        reject(err);
                    }
                };

                reader.onerror = () => reject(err);

                reader.readAsText(err.response.data);
            });
        } else {
            return err.response;
        }
    },
);

function setAccessToken(accessToken) {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
}

function getAccessToken() {
    const accessToken = apiClient.defaults.headers.common["Authorization"];
    return accessToken;
}

function getBackendApiUrl() {
    return backendApiUrl;
}

function resolveBackendHost() {
    return config.backend.apiUrl;
}

export { apiClient, apiErrorEvent, setAccessToken, getAccessToken, getBackendApiUrl, resolveBackendHost };
